/* eslint-disable jsx-a11y/anchor-is-valid */
import { Route, Routes } from "react-router-dom";
import { createContext } from "react";
import { SlotListing } from "../../modules/slot/component/SlotListing";


const SlotContext = createContext();

const SlotWrapper = () => {
  const value = {};

  return (
    <SlotContext.Provider value={value}>
      <Routes>
        <Route path="/:companyCode" element={<SlotListing />} />
      </Routes>
    </SlotContext.Provider>
  );
};

export { SlotWrapper };
